import { getStorageSync, removeStorageSync, setStorageSync } from '@/utils/storage.js';

export const GXZZ_STORAGE_KEY = 'isGxzz';

function normalizeBoolean(value: unknown) {
	if (typeof value === 'boolean') return value;
	if (typeof value === 'number') return value === 1;
	if (typeof value === 'string') {
		const normalized = value.trim().toLowerCase();
		return normalized === 'true' || normalized === '1';
	}
	return false;
}

export function getIsGxzzSession() {
	if (!import.meta.client) return false;
	return normalizeBoolean(getStorageSync(GXZZ_STORAGE_KEY));
}

export function setIsGxzzSession(value: boolean) {
	if (!import.meta.client) return;
	setStorageSync(GXZZ_STORAGE_KEY, Boolean(value));
}

export function clearIsGxzzSession() {
	if (!import.meta.client) return;
	removeStorageSync(GXZZ_STORAGE_KEY);
}
